import type { ReactNode } from 'react'

import { Container } from './Container'

type Props = {
	isVisible: boolean
	label: ReactNode
}

export const InlineValue = ({ isVisible, label }: Props) => {
	if (!isVisible) return null
	const isContentString = typeof label === 'string'

	return <Container isContentString={isContentString}>{isContentString ? <span>{label}</span> : label}</Container>
}
